import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=015fbf1d&scoped=true"
import script from "./Queue.vue?vue&type=script&lang=js"
export * from "./Queue.vue?vue&type=script&lang=js"
import style0 from "./Queue.vue?vue&type=style&index=0&id=015fbf1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015fbf1d",
  null
  
)

export default component.exports